import React from "react";

const IconChevronUp = (props) => {
  return (
    <svg
      width={props.width ?? "22"}
      height={props.height ?? "22"}
      viewBox="0 0 14.459 8.23"
      {...props}
    >
      <path
        id="chevron-down"
        d="M11.631,5.815,5.815,0,0,5.815"
        transform="translate(1.414 1)"
        fill="none"
        stroke={props.color ?? "#000"}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
    </svg>
  );
};

export default IconChevronUp;
